import React from 'react'
import Item from '../Item/Item'
import '../ItemList/ItemList.css'
const ItemList = ({item}) => {
  
  return (
    <div className='row' id='itemList'>
      {item.map(i =>

        <Item key={i.id} item= {i} />
        )}
     

    </div>

  ) 
}
 
export default ItemList